import styled from 'styled-components';

import { Text } from '../../../../components/Text/Text';
import { ANIM, COLORS, SPACE } from '../../../../theme/tokens';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

/** The text box and its character count (pinned in its lower-right corner). */
export const InputWrap = styled.div`
  position: relative;
`;

/* The shared TextArea's surface, without its label row: the accordion section already titles it "Direction". */
export const Input = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  min-height: 96px;
  max-height: 800px;
  field-sizing: content;
  resize: none;
  overflow-y: auto;
  /* 14px: the shared TextArea's block padding (off the scale on purpose); the bottom leaves room for the count. */
  padding: 14px ${SPACE[16]} ${SPACE[32]};
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  color: ${COLORS.text};
  font-size: 16px;
  font-family: inherit;
  line-height: 1.5;
  outline: none;
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  &:focus {
    border-color: ${COLORS.ctaSolid};
  }

  &::placeholder {
    color: ${COLORS.textFaint};
  }
`;

export const Count = styled.span`
  position: absolute;
  right: ${SPACE[12]};
  bottom: ${SPACE[8]};
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  color: ${COLORS.textFaint};
  pointer-events: none;
`;

export const Helper = styled(Text)`
  font-size: 11.5px;
  line-height: 1.4;
  color: ${COLORS.textFaint};
`;
